export default __webpack_public_path__ + "static/media/imgDarkEn8.a5581cc6.png";